// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demographic-card {
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    overflow: visible;
}
.demographic-card-header {
    align-items: center;
    display: flex;
    flex-grow: 1;
    border-bottom: none;
}
.card-title {
    margin-bottom: 0;
    flex-grow: 1;
    padding-top: 0px;
    padding-bottom: 0px;
}
.demographic-card-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.pie-chart-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    align-items: flex-start;
}
.pie-container {
    width: 23.5%;
    height: 200px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;


    background: #FFFFFF;
}
.pie-container:not(:last-of-type){

    border-right: 2px dashed rgba(204, 25, 119, 0.47);

}

.profile-card {
    max-height: 200px;
    min-height: 200px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
}
@media (max-width: 768px) {
    .pie-chart-container {
        flex-direction: column;
    }
    .pie-container {
        width: 100%;
        margin: 10px 0;
    }
}
.chart-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}
.chart-icon {
    margin-right: 5px;
    width: 30px;
    height: 30px;
}
.chart-text {
    margin-top: -2px;
    font-size: 15px;
}
svg {
    overflow: visible;
}
.real-life-interests-card {
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    align-items: center;
}
.real-life-interests-card-header {
    justify-content: center;
    display: flex;
    flex-grow: 0;
    border: 0;
    padding-bottom: 0;
}
.real-life-interests-card-title {
    margin-bottom: 0;
    padding-top: 4px;
    padding-bottom: 20px;
    padding-left: -5;  /* Daha az padding sol tarafta */
    padding-right: -5; /* Daha az padding sağ tarafta */
    border-bottom: 1px solid #ddd;
}
.real-life-interests-card-body {
    min-height: 355px;
    padding: 0 15px;
    width: 100%;
}
.real-life-interests-chart-container {
    min-height: 355px;
    max-height: 355px;
    padding-right: 15px;
    padding-left: 15px;
    overflow: auto;
}

.heat-map-card .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
  }
  
  .heat-map-card .card-body {
    height: 400px;
    position: relative;
  }
  
.profile-analysis-text {
    font-size: 14px;
    text-align: left;
    padding-top: 30px;
}
.back-button {
    margin-bottom: 10px;
    margin-left: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.spacer {
    flex-grow: 0.4;
}`, "",{"version":3,"sources":["webpack://./src/pages/pages/audience/Audience.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;;;IAGb,mBAAmB;AACvB;AACA;;IAEI,iDAAiD;;AAErD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB,GAAG,gCAAgC;IACnD,iBAAiB,EAAE,gCAAgC;IACnD,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB","sourcesContent":[".demographic-card {\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n}\n.demographic-card-header {\n    align-items: center;\n    display: flex;\n    flex-grow: 1;\n    border-bottom: none;\n}\n.card-title {\n    margin-bottom: 0;\n    flex-grow: 1;\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n.demographic-card-body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n}\n.pie-chart-container {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    width: 100%;\n    align-items: flex-start;\n}\n.pie-container {\n    width: 23.5%;\n    height: 200px;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 15px;\n\n\n    background: #FFFFFF;\n}\n.pie-container:not(:last-of-type){\n\n    border-right: 2px dashed rgba(204, 25, 119, 0.47);\n\n}\n\n.profile-card {\n    max-height: 200px;\n    min-height: 200px;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n}\n@media (max-width: 768px) {\n    .pie-chart-container {\n        flex-direction: column;\n    }\n    .pie-container {\n        width: 100%;\n        margin: 10px 0;\n    }\n}\n.chart-title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n}\n.chart-icon {\n    margin-right: 5px;\n    width: 30px;\n    height: 30px;\n}\n.chart-text {\n    margin-top: -2px;\n    font-size: 15px;\n}\nsvg {\n    overflow: visible;\n}\n.real-life-interests-card {\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    align-items: center;\n}\n.real-life-interests-card-header {\n    justify-content: center;\n    display: flex;\n    flex-grow: 0;\n    border: 0;\n    padding-bottom: 0;\n}\n.real-life-interests-card-title {\n    margin-bottom: 0;\n    padding-top: 4px;\n    padding-bottom: 20px;\n    padding-left: -5;  /* Daha az padding sol tarafta */\n    padding-right: -5; /* Daha az padding sağ tarafta */\n    border-bottom: 1px solid #ddd;\n}\n.real-life-interests-card-body {\n    min-height: 355px;\n    padding: 0 15px;\n    width: 100%;\n}\n.real-life-interests-chart-container {\n    min-height: 355px;\n    max-height: 355px;\n    padding-right: 15px;\n    padding-left: 15px;\n    overflow: auto;\n}\n\n.heat-map-card .card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem;\n  }\n  \n  .heat-map-card .card-body {\n    height: 400px;\n    position: relative;\n  }\n  \n.profile-analysis-text {\n    font-size: 14px;\n    text-align: left;\n    padding-top: 30px;\n}\n.back-button {\n    margin-bottom: 10px;\n    margin-left: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.spacer {\n    flex-grow: 0.4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
